import { computed, type ComputedRef } from 'vue';
import { useStore } from 'vuex';

import { SESSION_MODULE } from '@/store/session-module';
import { IS_BETA } from '@/store/session-module/getters';

export function useBetaHelper(): {
    isBeta: ComputedRef<boolean>;
} {
    const store = useStore();

    const isBeta = computed(() => {
        return store.getters[`${SESSION_MODULE}/${IS_BETA}`];
    });

    return { isBeta };
}
